import { HQO_SDK_EVENT_SUFFIX } from './sdk.constants';
import { SdkResponseEvent } from './types/sdk-handler.types';
import { HQO_SDK_ACTIONS } from './types/sdk-message.types';

export const isString = (candidate: unknown): candidate is string => typeof candidate === 'string';

export const isPlainObject = (candidate: unknown): candidate is Record<string, unknown> =>
  typeof candidate === 'object' &&
  candidate !== null &&
  candidate.constructor === Object &&
  Object.prototype.toString.call(candidate) === '[object Object]';

export const response = <T extends HQO_SDK_ACTIONS>(action: T): SdkResponseEvent<T> =>
  `${action}${HQO_SDK_EVENT_SUFFIX}`;

export const parseJson = (text: string): string | Record<string, unknown> => {
  try {
    return JSON.parse(text);
  } catch (_error) {
    return text;
  }
};
